import React from "react";
import "./SuccessRegistrationPage.css";

/**
 * Full-viewport centered card layout for registration billing return (success / loading / error).
 * No split hero image — replaces AgentRegisterShell for this flow only.
 */
export default function SuccessRegistrationPage({ children }) {
  return (
    <div className="success-reg-page" dir="rtl" lang="he">
      <div className="success-reg-page__gradient" aria-hidden />
      <main className="success-reg-page__main">
        <div className="success-reg-page__card">{children}</div>
      </main>
    </div>
  );
}
